export const billingPayments = {
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		marginBottom: '0px',
		justifyContent: 'space-between',

		'@media (min-width: 1200px)': {
			marginBottom: '16px',
		},
	},
	paymentItem: {
		display: 'flex',
		flexDirection: 'column',
		padding: '16px',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		width: 'calc(33.3% - 48px / 3)',
		marginRight: '24px',
		'&:last-of-type': {
			marginRight: '0',
		},
	},
	paymentHead: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '8px',
	},

	iconWrap: {
		width: '44px',
		height: '44px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		padding: '5px',
		marginRight: '24px',
	},
	title: {
		fontSize: '16px',
		lineHeight: '1.6',
		fontWeight: '700',
	},
	description: {
		fontSize: '14px',
		lineHeight: '1.43',
		color: 'var(--neutral-300)',
		marginBottom: '16px',
	},
	btn: {
		marginTop: 'auto',
	},
	stripe: {
		backgroundColor: 'var(--background-stripe)',
		'&:hover': {
			backgroundColor: 'var(--background-stripe-hover)',
		},
		'&:active': {
			backgroundColor: 'var(--background-stripe-active)',
		},
	},
	square: {
		backgroundColor: 'var(--background-square)',
		'&:hover': {
			backgroundColor: 'var(--background-square-hover)',
		},
		'&:active': {
			backgroundColor: 'var(--background-square-active)',
		},
	},
	paypal: {
		backgroundColor: 'var(--background-paypal)',
		'&:hover': {
			backgroundColor: 'var(--background-paypal-hover)',
		},
		'&:active': {
			backgroundColor: 'var(--background-paypal-active)',
		},
	},
};
